import Searchbar from './searchbar.vue'
import DataGrid from './data-grid.vue'
import TreeDataGrid from './tree-data-grid'
import TabDataGrid from './tab-data-grid'
import TabDataGridItem from './tab-data-grid-item'
import ProfileBasic from './profile-basic'
import ProfileStatusBar from './profile-status-bar'
import VLayout from './layout'

Searchbar.install = Vue => {
  Vue.component(Searchbar.name, Searchbar)
}

DataGrid.install = Vue => {
  Vue.component(DataGrid.name, DataGrid)
}

TreeDataGrid.install = Vue => {
  Vue.component(TreeDataGrid.name, TreeDataGrid)
}

TabDataGrid.install = Vue => {
  Vue.component(TabDataGrid.name, TabDataGrid)
}

TabDataGridItem.install = Vue => {
  Vue.component(TabDataGridItem.name, TabDataGridItem)
}

ProfileBasic.install = Vue => {
  Vue.component(ProfileBasic.name, ProfileBasic)
}

ProfileStatusBar.install = Vue => {
  Vue.component(ProfileStatusBar.name, ProfileStatusBar)
}

VLayout.install = Vue => {
  Vue.component(VLayout.name, VLayout)
}

export {
  Searchbar,
  DataGrid,
  TreeDataGrid,
  TabDataGrid,
  TabDataGridItem,
  ProfileBasic,
  ProfileStatusBar,
  VLayout
}



// WEBPACK FOOTER //
// ./src/components/layouts/index.js